import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { ViewOffer,OfferSuccess,OfferActionTypes,OfferFailure } from '../actions/offerActions';
import { ChangeOfferFailure,ChangeOfferSuccess,ChangeOfferStatus } from '../actions/offerActions';
import { Request,RequestFailure,RequestSuccess } from '../actions/offerActions';

import { ViewoffersService } from 'src/app/modules/dashboard/viewoffers/viewoffers.service';
import { ViewrequestsService } from 'src/app/modules/dashboard/viewrequests/viewrequests.service';


import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';


@Injectable()
export class OfferEffects {

  constructor(
    private actions: Actions,
    private offerService: ViewoffersService,
    private requestService: ViewrequestsService,
    

  ) { }

  @Effect()
  ViewOffer: Observable<any> = this.actions
    .ofType(OfferActionTypes.VIEW_OFFER)
    .map((action: ViewOffer) => [action.id,action.payload])
    .mergeMap(payload => {
      console.log(payload);
       return this.offerService.viewAllOffers(payload[0],payload[1])
        .map((data) => {
          console.log("data", data);
          if (!data.success) {
            return new OfferFailure({ error: data });
          }
          return new OfferSuccess({
            success: data.success,
            successMessage: data.message,
            data: data.data
          });

        })
        .catch((error) => {
          return Observable.of(new OfferFailure({ error: error }));
        }); 
    });
    
    @Effect()
    ChangeOfferStatus: Observable<any> = this.actions
    .ofType(OfferActionTypes.OFFER_STATUS_CHANGE)
    .map((action: ChangeOfferStatus) => [action.id,action.payload])
    .mergeMap(payload => {
      console.log(payload);
       return this.offerService.offerStatusChange(payload[0],payload[1])
        .map((data) => {
          console.log("data", data);
          if (!data.success) {
            return new ChangeOfferFailure({ error: data });
          }
          return new ChangeOfferSuccess({
            success: data.success,
            successMessage: data.message,
            data: data.data
          });

        })
        .catch((error) => {
          return Observable.of(new ChangeOfferFailure({ error: error }));
        }); 
    });
    @Effect()
    Request: Observable<any> = this.actions
      .ofType(OfferActionTypes.REQUEST)
      .map((action: Request) => action.payload)
      .mergeMap(payload => {
        return this.requestService.viewAllRequests(payload)
          .map((data) => {
            console.log("view-request ", data);
            if (!data.success) {
              return new RequestFailure({ error: data });
            }
            return new RequestSuccess({
              success: data.success,
              successMessage: data.message,
              data: data.data
            });
  
          })
          .catch((error) => {
            return Observable.of(new RequestFailure({ error: error }));
          });
      });
}

